module.exports = __webpack_public_path__ + "r-v3/img/ml_05_01_over.4309b661.jpg";